/* eslint-disable */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// TEAM BONUS stat card — always visible next to "BONUS — Ce Cycle".
export const TeamBonusStatCard = ({ userId, testid = "stat-team-bonus" }) => {
  const [d, setD] = useState({ total_active: 0, credited: 0, pending: 0 });
  useEffect(() => {
    if (!userId) return;
    const load = () => axios.get(`${API}/user/${userId}/team-bonus-active`).then((r) => setD(r.data)).catch(() => {});
    load(); const t = setInterval(load, 60000); return () => clearInterval(t);
  }, [userId]);
  const total = Number(d.total_active || 0);
  const sub = d.credited > 0 ? "Ajouté à votre solde" : d.pending > 0 ? "Ajouté au prochain contrôle" : "Aucun pour l'instant";
  return (
    <div className="bg-gradient-to-br from-amber-100 to-yellow-300 border border-amber-400 rounded-2xl p-4 shadow-sm hover:shadow-md transition" data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <div className="w-10 h-10 rounded-xl bg-amber-500/30 flex items-center justify-center"><Star className="w-5 h-5 text-amber-800" /></div>
        {total > 0 && <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />}
      </div>
      <p className="text-amber-950 text-[11px] font-bold uppercase tracking-wider">Team Bonus</p>
      <p className="text-amber-950 font-black text-3xl mt-0.5" data-testid={`${testid}-amount`}>${total.toFixed(2)}</p>
      <p className="text-amber-800 text-[10px] font-semibold mt-0.5" data-testid={`${testid}-status`}>{sub}</p>
    </div>
  );
};
